import React from "react";
import { Box, Typography } from "@mui/material";

const SoldText = ({
  totalSoldCount,
  totalSoldUsdCents,
  stats,
  userIsAdmin,
  capacity,
}) => {
  const hasStatsRevenue =
    stats && (stats.totalUsdCents !== undefined || stats.refundedUsdCents !== undefined);
  const totalCollected = stats?.totalUsdCents ?? 0;
  const refundedUsdCents = stats?.refundedUsdCents ?? 0;
  const netSalesUsdCents = totalCollected - refundedUsdCents;

  if (userIsAdmin) {
    let totalUsdText = "";
    let USDollar = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    if (hasStatsRevenue) {
      totalUsdText = USDollar.format(netSalesUsdCents / 100);
    } else if (totalSoldUsdCents !== undefined) {
      // handle events that were created before net sales were calculated
      totalUsdText = USDollar.format(totalSoldUsdCents / 100);
    }

    return (
      <Box display={"flex"} flexDirection={"column"} sx={{ height: "100%" }}>
        <Typography variant="body2" color={"text.primary"}>
          {capacity
            ? `Sold: ${totalSoldCount}/${capacity}`
            : `Sold: ${totalSoldCount}`}
        </Typography>
        <Typography variant="body2" color={"text.primary"}>
          {totalUsdText}
        </Typography>
      </Box>
    );
  }

  return null;
};

export default SoldText;
